import { useCallback } from "react";

// =============================================================================
// useTheme — LIGHT MODE ONLY
// =============================================================================
// Dark and auto modes have been removed. Altara is light-mode-only.
// This hook exists to maintain the interface for consumers.
// Public routes override via useGlassStyle's forceLightMode option.
// =============================================================================

export type ThemeMode = "light";

export const useTheme = () => {
  // Always light mode — no toggling, no dark, no auto
  const isLightMode = true;
  const mode: ThemeMode = "light";

  // No-ops — kept for interface compatibility
  const cycleMode = useCallback(() => {}, []);
  const setThemeMode = useCallback((_newMode: string) => {}, []);

  return {
    mode,
    isLightMode,
    cycleMode,
    setThemeMode,
    backgroundOverride: null as string | null, // No override — use org background as-is
    canToggleTheme: false,
    // Legacy export
    toggleLightMode: cycleMode,
  };
};
